import { IconWrapper } from '../runtime';
export default IconWrapper('save-as', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.25 11.4998H3.25C2.42157 11.4998 1.75 10.8282 1.75 9.99982V3.49982C1.75 2.67139 2.42157 1.99982 3.25 1.99982H7.75C8.57843 1.99982 9.25 2.67139 9.25 3.49982M6.75 7.24982V6.49982C6.75 5.67139 7.42157 4.99982 8.25 4.99982H12.75C13.5784 4.99982 14.25 5.67139 14.25 6.49982V12.9998C14.25 13.8282 13.5784 14.4998 12.75 14.4998H8.25C7.42157 14.4998 6.75 13.8282 6.75 12.9998V12.2498",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.75 9.74985H11.25M11.25 9.74985L9.75 8.49985M11.25 9.74985L9.75 10.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});